export class RestoreGoogleWorkspaceSharedDriveByEntityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "GoogleWorkspaceSharedDriveRestoreScope",
            "format": ""
        },
        {
            "name": "entireSharedDrive",
            "baseName": "entireSharedDrive",
            "type": "GoogleWorkspaceSharedDriveEntireDriveOptions",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "GoogleWorkspaceSharedDriveSelectedItemsOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceSharedDriveByEntityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
